import React from 'react'
import { CircularProgress, Grid } from '@mui/material'
import { NoDataFound } from '@components'
import LoadingText from 'Pages/ReportsAlerts/Reports/@components/CrudTable/LoadingText'
import useRatingHistorical from 'Pages/ReportsAlerts/Reports/@hooks/useRatingHistorical'
import RatingHistoryTable from './RatingTable'


export default function RatingHistoricalContent({ idReport }) {
	const { reportName, data, isLoading } = useRatingHistorical(idReport)

	return <Grid container spacing={2}>
		{isLoading && <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 4 }}>
			<LoadingText label="Loading historical" variant="subtitle1" sx={{ my: 2 }}/>
			<CircularProgress size={120}/>
		</Grid>}

		{!isLoading && !data.length && <Grid item xs={12}>
			<NoDataFound/>
		</Grid>}

		{!isLoading && !!data.length && <Grid item xs={12}>
			<RatingHistoryTable reportName={reportName} data={data}/>
		</Grid>}
	</Grid>
}